import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { KitService } from '../customerOverview/effects';
import { ProfileService } from '../profile/effects';
import { Kit, getKitProfileId, Profile } from '../../models/customerOverview';
import { ErrorResponse, APIError } from '../../helpers/types';
import { ActionStartFetchingKits, CustomerDetailActionTypes, ActionFetchKitSuccessActions, CustomerDetailsThunkDispatch, ActionFetchProfileSuccessActions, ActionDownloadReport, ActionUserProfileSendReportSubmitSuccess, ActionUserProfileDownloadReportSubmitError, ActionResetCustomerDetails } from './types';
import { DownloadReportFormPayload, DownloadReportFormResponse } from '../../models/profile';

export const dispatchFetchKits = (): ActionStartFetchingKits => {
  return {
    type: CustomerDetailActionTypes.START_FETCHING_KITS,
  };
};

export const dispatchFetchKitsSuccess = (payload: Kit): ActionFetchKitSuccessActions => {
  return {
    type: CustomerDetailActionTypes.FETCH_KITS_SUCCESS,
    payload,
  };
};

export const dispatchFetchProfilesSuccess = (payload: Profile): ActionFetchProfileSuccessActions => {
  return {
    type: CustomerDetailActionTypes.FETCH_PROFILES_SUCCESS,
    payload,
  };
};

export const dispatchResetCustomerDetails = (): ActionResetCustomerDetails => {
  return {
    type: CustomerDetailActionTypes.ACTION_RESET_CUSTOMER_DETAILS,
  };
};

export const actionFetchKitsByBarcode = (barcode: string) => (dispatch: CustomerDetailsThunkDispatch) => {
  return fetchSingleKit(dispatch, KitService.fetchKitByBarcode, barcode);
};
export const dispatchUserProfileDownloadReportSubmit = (payload: DownloadReportFormPayload): ActionDownloadReport => {
  return {
    type: CustomerDetailActionTypes.ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT,
    payload,
  };
};
export const dispatchUserProfileDownloadReportSubmitSuccess = (payload: DownloadReportFormResponse): ActionUserProfileSendReportSubmitSuccess => {
  return {
    type: CustomerDetailActionTypes.ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT_SUCCESS,
    payload,
  };
};

export const dispatchUserProfileDownloadReportSubmitError = (e: APIError): ActionUserProfileDownloadReportSubmitError => {
  return {
    type: CustomerDetailActionTypes.ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT_ERROR,
    error: e,
  };
};

export const actionDownloadPdfReport = (payload: DownloadReportFormPayload) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchUserProfileDownloadReportSubmit(payload));
    return ProfileService.downloadReport(payload).then((response) => {
      return dispatch(dispatchUserProfileDownloadReportSubmitSuccess(response));
    }).catch((e: ErrorResponse) => {
      return dispatch(dispatchUserProfileDownloadReportSubmitError(e.response));
    });
  };
};

export const actionResetCustomerDetails = () => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchResetCustomerDetails());
  };
};

async function fetchSingleKit(
  dispatch: CustomerDetailsThunkDispatch,
  fetcher: (barcodeOrKitId: string) => Promise<Kit | undefined>,
  barcodeOrKitId: string,
) {
  dispatch(dispatchFetchKits());
  const kit = await fetcher(barcodeOrKitId);
  if (kit) {
    const kitProfileId = getKitProfileId(kit);
    dispatch(dispatchFetchKitsSuccess(kit));
    if (kitProfileId) {
      const profiles = await ProfileService.fetchProfiles([kitProfileId]);
      dispatch(dispatchFetchProfilesSuccess(profiles[0]));
    }
  }
}
